<table mat-table [dataSource]="citysStatus" class="mat-elevation-z8">

    <!--- Note that these columns can be defined in any order.
          The actual rendered columns are set as a property on the row definition" -->
  

    <!-- Name Column -->
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef> Name </th>
      <td mat-cell *matCellDef="let element"> <h3>{{ element.idCity.name }}</h3> </td>
    </ng-container>
  
    <!-- Weight Column -->
    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef> Status </th>
      <td mat-cell *matCellDef="let element"> 
        <mat-selection-list disabled="true">
            <mat-list-option *ngFor="let status of listStatus"  selected="{{ status.id <= element.status}}">
              {{status.text}}
            </mat-list-option>
          </mat-selection-list>
      </td>
    </ng-container>
  

  
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

